import React, { useContext } from "react";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { DocumentDetailContext } from "../../contexts/DocumentDetailContext";
import { CustomTooltip } from "components/CustomTooltip/CustomTooltip";
import * as msg from "utils/constants/messages";

const DocNavigation = () => {
    const { _baseClassName, getDocId, gotToDocMgmt } = useContext(DocumentDetailContext);

    return <div className={`${_baseClassName}-doc-navigation`}>
        <CustomTooltip title={false ? msg.stat_tooltip : ""} placement="bottom-end">
            <div className={`${_baseClassName}-navigation-btn prev-btn`} onClick={() => getDocId("prev")}>
                <ArrowLeft />
                <span>Prev</span>
            </div>
        </CustomTooltip>
        <CustomTooltip title={false ? msg.stat_tooltip : ""} placement="bottom-end">
            <div className={`${_baseClassName}-navigation-btn next-btn`} onClick={() => getDocId("next")}>
                <span>Next</span>
                <ArrowRight />
            </div>
        </CustomTooltip>
        <CustomTooltip title={false ? msg.stat_tooltip : ""} placement="bottom-end">
            <div className={`${_baseClassName}-navigation-btn next-btn`} onClick={gotToDocMgmt}>
                <span>Back to Document List</span>
            </div>
        </CustomTooltip>

    </div>
}

export default DocNavigation;